<div class="content">

  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header >
        <mat-panel-title>
          Consultar tarifas por línea
        </mat-panel-title>
      </mat-expansion-panel-header>

        <mat-form-field appearance="fill">
          <mat-label>Selecciona la línea</mat-label>
          <mat-select [(value)]="selectedLine" (selectionChange)="getTarifaPorLinea($event)">
            <mat-option class="optionLine" *ngFor="let bus of listOfBus" [value]="bus.route_id">
              {{bus.route_long_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-spinner *ngIf="SpinnerSearch"></mat-spinner>

        <ng-container *ngFor="let rates of ratesLine">
          <mat-card class="gradient-border-card">
              <mat-card-header>
                <mat-card-title>{{ rates.DescripcionTipoBill }}</mat-card-title>
                <mat-card-subtitle> {{ rates.Observacion }}</mat-card-subtitle>
              </mat-card-header>
              <div class="import-bill">
                <button mat-raised-button disabled style="background-color: rgb(255, 255, 255); color: black;">
                  {{ rates.Importbill }}€
                </button>
              </div>
          </mat-card>
        </ng-container>

    </mat-expansion-panel>

    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title style="padding-top: 10px;">
          Consultar tarifa por trayecto
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-vertical-stepper linear="true" #stepper>
        <mat-step [stepControl]="origen" label="Estación de origen">
          <form [formGroup]="origen">
            <mat-form-field>
              <mat-label>Selecciona estación de origen</mat-label>
              <mat-select formControlName="secondCtrl" panelClass="selectionPanel" required>
                <mat-option *ngFor="let station of allStations" [value]="station">{{station.stop_name | titlecase}}</mat-option>
              </mat-select>
              <mat-error *ngIf="origen.hasError('required')">Por favor, selecciona estación</mat-error>
            </mat-form-field>
            <div>
              <button mat-raised-button class="custom-color" matStepperNext>Siguiente</button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="destino" label="Estación de destino">
          <form [formGroup]="destino">
            <mat-form-field>
              <mat-label>Selecciona estación de destino</mat-label>
              <mat-select formControlName="thirdCtrl" panelClass="selectionPanel" required>
                <mat-option *ngFor="let station of allStations" [value]="station">{{station.stop_name | titlecase}}</mat-option>
              </mat-select>
              <mat-error *ngIf="destino.hasError('required')">Por favor, selecciona estación</mat-error>
            </mat-form-field>
            <div>
              <button mat-raised-button color="" matStepperPrevious style="margin-right: 10px; margin-bottom: 10px;">Atrás</button>
              <button mat-raised-button color="warn" (click)="stepper.reset()" style="margin-right: 10px; margin-bottom: 10px;">Reiniciar</button>
              <button mat-raised-button color="" class="custom-color" (click)="calculate()">Calcular</button>
            </div>
          </form>
        </mat-step>
      </mat-vertical-stepper>

    </mat-expansion-panel>
  </mat-accordion>
  <h5 style="padding-left: 5px; padding-top: 10px;">
    *Cambio máximo autorizado: 10,00 € · Rogamos facilite importe exacto. Por favor recoja su billete y consérvelo durante el trayecto.
  </h5>
  <a mat-button href="https://atmv.gva.es/es/titols-i-tarifes/titols-i-tarifes" target="_blank" style="display: block;">+ Info</a>


  </div>

